const ErrorBoundary = () => {
    return (
        <div>ERROR BOUDNARY...</div>
    )
}

export default ErrorBoundary